import type { LucideIcon } from "lucide-react";
import CardGrid from "@/components/sections/CardGrid";

interface FeatureItem {
  icon?: LucideIcon;
  title: string;
  description: string;
}

interface FeatureGridProps {
  items: FeatureItem[];
  columns?: 2 | 3 | 4;
}

/**
 * Thin wrapper around CardGrid for semantic clarity.
 * Use FeatureGrid for benefits/features lists; CardGrid remains
 * available for other card-based layouts (with images, etc.).
 */
const FeatureGrid = ({ items, columns = 3 }: FeatureGridProps) => {
  return <CardGrid items={items} columns={columns} />;
};

export default FeatureGrid;
